module.exports = __webpack_public_path__ + "static/media/newline3.a11744d0.jpg";